import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import promiseMiddleware from 'redux-promise'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router/immutable'
import createRootReducer from './reducer'
import { setStore, getStore } from '../utils/storeHelper'

export const history = createBrowserHistory()

const store = createStore(
  createRootReducer(history),
  compose(applyMiddleware(routerMiddleware(history), thunk, promiseMiddleware))
)
setStore(store)
export default store
